import { Component, OnInit } from '@angular/core';


@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html"
})
export class FooterComponent implements OnInit {


    constructor() {

    }
    ngOnInit() {

    }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/layouts/footer/footer.component.ts